import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY

const supabase = createClient(supabaseUrl, supabaseAnonKey)

console.log("Supabase URL:", supabaseUrl); // Musi wypisać URL
console.log("Supabase Key exists:", !!supabaseAnonKey); // Musi wypisać true

export default supabase